import { inject } from 'vue';
import { projectKey } from '../keys';

export function useProjectInjection() {
    const projectInjection = inject(projectKey);
    if (!projectInjection) {
        throw new Error('Project not properly injected');
    }
    return projectInjection;
}
